import { Badge, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { AvatarSizeEnum } from '@shared/enums/avatarSize.enum';

import type { AvatarBudgeSize } from '@shared/enums/avatarSize.enum';

export const OnlineAvatarBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: AvatarSizeEnum }>(({ theme, size }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.primary.main,
    width: size === AvatarSizeEnum.size24 ? '4px' : '8px',
    height: size === AvatarSizeEnum.size24 ? '4px' : '8px',
    border: '1px solid #ffffff',
    borderRadius: '50%',
    minWidth: '4px',
    color: theme.palette.primary.main,
  },
}));

export const HubsAvatarBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: AvatarSizeEnum }>(({ size }) => ({
  '& .MuiBadge-badge': {
    width: size === AvatarSizeEnum.size24 ? '4px' : '20px',
    height: size === AvatarSizeEnum.size24 ? '4px' : '20px',
    backgroundColor: 'initial',
    border: 'initial',
    borderRadius: '50%',
    display: 'block',
    right: '38%',

    svg: {
      height: '14px',
      width: '14px',
    },
  },

  '&:hover': {
    '& .add-icon': {
      display: 'flex',
    },
  },
}));

export const AddIconContainer = styled(Box)(({ theme }) => ({
  maxHeight: '32px',
  position: 'absolute',
  bottom: 0,
  background: theme.palette.case.neutral.n900,
  opacity: '0.64',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const CustomBadge = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['backgroundColor', 'iconColor', 'badgeSize', 'avatarVariant'].includes(prop),
})<{
  backgroundColor: string;
  badgeSize: AvatarBudgeSize;
  avatarVariant: 'circular' | 'rounded';
  iconColor?: string;
}>(({ theme, backgroundColor, iconColor, badgeSize, avatarVariant }) => ({
  position: 'absolute',
  bottom: avatarVariant === 'circular' ? '14%' : '13%',
  right: avatarVariant === 'circular' ? '20%' : '11%',
  height: badgeSize,
  width: badgeSize,
  padding: '1px',
  border: `1px solid ${theme.palette.case.contrast.white}`,
  backgroundColor: backgroundColor,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transform: 'translate(50%, 50%)',

  svg: {
    height: `calc(${badgeSize}px - 2px)`,
    width: `calc(${badgeSize}px - 2px)`,
    path: {
      fill: iconColor || '',
    },
  },
}));
